import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, withModifiers as _withModifiers, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-cbaf396c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-scans-filter" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "filter-chip" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "From:", -1 /* HOISTED */))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "To:", -1 /* HOISTED */))
const _hoisted_8 = {
  key: 1,
  class: "mt-2"
}
const _hoisted_9 = { class: "filter-chip" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Starting from:", -1 /* HOISTED */))
const _hoisted_11 = {
  key: 2,
  class: "mt-2"
}
const _hoisted_12 = { class: "filter-chip" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Ending at:", -1 /* HOISTED */))
const _hoisted_14 = {
  key: 3,
  class: "mt-2"
}
const _hoisted_15 = { class: "filter-chip" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "From", -1 /* HOISTED */))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "To", -1 /* HOISTED */))
const _hoisted_18 = {
  key: 4,
  class: "mt-2"
}
const _hoisted_19 = { class: "filter-chip" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Value:", -1 /* HOISTED */))
const _hoisted_21 = {
  key: 0,
  class: "handle"
}
const _hoisted_22 = {
  key: 5,
  class: "mt-2"
}
const _hoisted_23 = { class: "filter-chip" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Response:", -1 /* HOISTED */))
const _hoisted_25 = {
  key: 0,
  class: "handle"
}
const _hoisted_26 = {
  key: 6,
  class: "mt-2"
}
const _hoisted_27 = { class: "filter-chip" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Property:", -1 /* HOISTED */))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, "Name", -1 /* HOISTED */))
const _hoisted_30 = { class: "handle" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, "Value", -1 /* HOISTED */))
const _hoisted_32 = { class: "handle" }
const _hoisted_33 = {
  key: 7,
  class: "mt-2"
}
const _hoisted_34 = { class: "filter-chip" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Answer:", -1 /* HOISTED */))
const _hoisted_36 = { class: "handle" }
const _hoisted_37 = {
  key: 8,
  class: "mt-2"
}
const _hoisted_38 = { class: "filter-chip" }
const _hoisted_39 = {
  key: 9,
  class: "mt-2"
}
const _hoisted_40 = { class: "filter-chip" }
const _hoisted_41 = {
  key: 10,
  class: "mt-2"
}
const _hoisted_42 = { class: "filter-chip" }
const _hoisted_43 = {
  key: 11,
  class: "mt-2"
}
const _hoisted_44 = { class: "filter-chip" }
const _hoisted_45 = {
  key: 12,
  class: "mt-2"
}
const _hoisted_46 = { class: "filter-chip" }
const _hoisted_47 = {
  key: 13,
  class: "mt-2"
}
const _hoisted_48 = { class: "filter-chip" }
const _hoisted_49 = {
  key: 14,
  class: "mt-2"
}
const _hoisted_50 = { class: "filter-chip" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Scan ID:", -1 /* HOISTED */))
const _hoisted_52 = {
  key: 15,
  class: "mt-2"
}
const _hoisted_53 = { class: "filter-chip" }
const _hoisted_54 = { key: 0 }
const _hoisted_55 = ["src"]
const _hoisted_56 = { key: 1 }
const _hoisted_57 = ["src"]
const _hoisted_58 = { key: 2 }
const _hoisted_59 = ["src"]
const _hoisted_60 = { key: 3 }
const _hoisted_61 = ["src"]
const _hoisted_62 = ["src"]
const _hoisted_63 = { key: 4 }
const _hoisted_64 = ["src"]
const _hoisted_65 = ["src"]
const _hoisted_66 = { key: 5 }
const _hoisted_67 = ["src"]
const _hoisted_68 = ["src"]
const _hoisted_69 = {
  key: 16,
  class: "mt-2"
}
const _hoisted_70 = { class: "filter-chip" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Uploaded: ", -1 /* HOISTED */))
const _hoisted_72 = {
  key: 17,
  class: "mt-2"
}
const _hoisted_73 = { class: "filter-chip" }
const _hoisted_74 = {
  key: 18,
  class: "mt-2"
}
const _hoisted_75 = { class: "filter-chip" }
const _hoisted_76 = {
  key: 19,
  class: "mt-2"
}
const _hoisted_77 = { class: "filter-chip" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Services: ", -1 /* HOISTED */))
const _hoisted_79 = {
  key: 20,
  class: "mt-2"
}
const _hoisted_80 = { class: "filter-chip" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Users: ", -1 /* HOISTED */))
const _hoisted_82 = {
  key: 21,
  class: "mt-2"
}
const _hoisted_83 = { class: "filter-chip" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Devices: ", -1 /* HOISTED */))
const _hoisted_85 = { class: "bg-grey-lighten-4 text-subtitle-1 font-weight-bold w-100 pa-2" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "my-2 d-block" }, "Barcode Value", -1 /* HOISTED */))
const _hoisted_87 = { class: "my-4" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "mb-2 d-block" }, "Search Response", -1 /* HOISTED */))
const _hoisted_89 = { key: 0 }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block mb-2" }, "Search Answers", -1 /* HOISTED */))
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block mb-2" }, "Scan Ids", -1 /* HOISTED */))
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "You can enter multiple comma-separated scan ID", -1 /* HOISTED */))
const _hoisted_93 = { class: "bg-grey-lighten-4 text-subtitle-1 font-weight-bold w-100 pa-2" }
const _hoisted_94 = { class: "bg-grey-lighten-4 text-subtitle-1 font-weight-bold w-100 pa-2" }
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "mb-2 d-block" }, "With these scan results:", -1 /* HOISTED */))
const _hoisted_96 = { class: "table sm-th" }
const _hoisted_97 = { key: 0 }
const _hoisted_98 = ["src"]
const _hoisted_99 = ["src"]
const _hoisted_100 = ["src"]
const _hoisted_101 = { class: "bg-grey-lighten-4 text-subtitle-1 font-weight-bold w-100 pa-2" }
const _hoisted_102 = {
  key: 0,
  class: "text-center"
}
const _hoisted_103 = { class: "mt-2" }
const _hoisted_104 = { class: "bg-grey-lighten-4 text-subtitle-1 font-weight-bold w-100 pa-2" }
const _hoisted_105 = {
  key: 0,
  class: "text-center"
}
const _hoisted_106 = { class: "mt-2" }
const _hoisted_107 = { class: "bg-grey-lighten-4 text-subtitle-1 font-weight-bold w-100 pa-2" }
const _hoisted_108 = {
  key: 0,
  class: "text-center"
}
const _hoisted_109 = { class: "mt-2" }
const _hoisted_110 = { class: "bg-grey-lighten-4 text-subtitle-1 font-weight-bold w-100 pa-2" }
const _hoisted_111 = { class: "mt-2" }
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_113 = { class: "text-center text-muted" }
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Loading, please wait...", -1 /* HOISTED */))
const _hoisted_115 = { key: 0 }
const _hoisted_116 = { class: "text-center" }
const _hoisted_117 = {
  key: 0,
  class: "text-center"
}
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "No Scans Found.", -1 /* HOISTED */))
const _hoisted_119 = [
  _hoisted_118
]
const _hoisted_120 = { key: 1 }

import { ref, watch, onMounted, computed } from 'vue';
import { useRoute, onBeforeRouteUpdate, useRouter } from 'vue-router';
import moment from 'moment';
import Paginator from '../service/PaginatorService';
import asset from '../service/AssetService';
import util from '../service/UtilService';
import flashMessenger from '../service/FlashMessenger';
import TimezoneListComponent from "./TimezoneListComponent.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ScanFilterComponent',
  props: {
  scanFilterStateV2: {
    type: Object,
    required: true
  },
  expandDateSectionByDefault: {
    type: Boolean,
    default: true
  }
},
  setup(__props) {

const props = __props;
const route = useRoute();
const router = useRouter();
const showScansModal = ref(false);
const showValidColor = ref(true);
const showInvalidColor = ref(true);
const showColor = ref(true);
const scanResults = ref(util.clone(props.scanFilterStateV2.settings.scan.result));
const scanClone = ref(util.clone(props.scanFilterStateV2.settings.scan));
const showValueMore = ref(false);
const showResponseMore = ref(false);
const showPropertyName = ref(false);
const showPropertyValue = ref(false);
const showAnswerMore = ref(false);
const showScansStartDate = ref('');
const showScansEndDate = ref('');
const uploadTimestamps = ref([]);
const serviceNames = ref([]);
const userNames = ref([]);
const deviceNames = ref([]);
const deletedServices = ref(util.clone(props.scanFilterStateV2.settings.services.deleted) || false);
const deletedUsers = ref(util.clone(props.scanFilterStateV2.settings.users.deleted) || false);
const services = ref(util.clone(props.scanFilterStateV2.settings.services.selected_ids) == undefined ? 'all' : util.clone(props.scanFilterStateV2.settings.services.selected_ids));
const users = ref(util.clone(props.scanFilterStateV2.settings.users.selected_ids) || 'all');
const scanStartDate = ref(util.clone(props.scanFilterStateV2.settings.scan.start_date) || '');
const scanEndDate = ref(util.clone(props.scanFilterStateV2.settings.scan.end_date) || '');
const scanDateFrom = ref(util.clone(props.scanFilterStateV2.settings.scan.date_from) || '');
const scanDateTo = ref(util.clone(props.scanFilterStateV2.settings.scan.date_to) || '');
const uploads = ref(util.clone(props.scanFilterStateV2.settings.scan.upload_ids) || []);
const devices = ref(util.clone(props.scanFilterStateV2.settings.devices.selected_ids) || []);
const displayFilters = ref((route.name as string).substring(0, 13) === 'account.scans');
const open = ref(['Users']);
const panel = ref(props.expandDateSectionByDefault ? [1] : []);

onBeforeRouteUpdate((to, from, next) => {
  scanResults.value = util.clone(props.scanFilterStateV2.settings.scan.result);
  scanClone.value = util.clone(props.scanFilterStateV2.settings.scan);
  deletedServices.value = util.clone(props.scanFilterStateV2.settings.services.deleted) || false;
  deletedUsers.value = util.clone(props.scanFilterStateV2.settings.users.deleted) || false;
  services.value = util.clone(props.scanFilterStateV2.settings.services.selected_ids) == undefined ? 'all' : util.clone(props.scanFilterStateV2.settings.services.selected_ids);
  users.value = util.clone(props.scanFilterStateV2.settings.users.selected_ids) || 'all';
  scanStartDate.value = util.clone(props.scanFilterStateV2.settings.scan.start_date) || '';
  scanEndDate.value = util.clone(props.scanFilterStateV2.settings.scan.end_date) || '';
  scanDateFrom.value = util.clone(props.scanFilterStateV2.settings.scan.date_from) || '';
  scanDateTo.value = util.clone(props.scanFilterStateV2.settings.scan.date_to) || '';
  uploads.value = util.clone(props.scanFilterStateV2.settings.scan.upload_ids) || [];
  devices.value = util.clone(props.scanFilterStateV2.settings.devices.selected_ids) || [];

  serviceNames.value = [];
  userNames.value = [];
  deviceNames.value = [];
  uploadTimestamps.value = [];

  next();

});

function updateServiceSelectAll(value: boolean) {
  props.scanFilterStateV2.settings.services.select_all = value;
}

function createPaginator() {
  props.scanFilterStateV2.paginator = new Paginator(() => {
    props.scanFilterStateV2.loadScans();
  });
}
watch(showScansModal, (newVal) => {
  if (newVal) {
    createPaginator();
  }
});

/*watch(() => props.scanFilterStateV2.paginator.currentPage, (newVal) => {
  props.scanFilterStateV2.loadScans()
});*/

watch(() => props.scanFilterStateV2.showScansStart, (newVal) => {
      if (newVal && props.scanFilterStateV2.showScansEnd) {
        showScansStartDate.value = moment(newVal, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm');
        showScansEndDate.value = moment(props.scanFilterStateV2.showScansEnd, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm');
      } else {
        showScansStartDate.value = '';
        showScansEndDate.value = '';
      }
    },
    { deep: true }
);

watch(() => props.scanFilterStateV2.settings.scan.p_metric, (newValue) => {
      if (newValue === 'minute' && (props.scanFilterStateV2.settings.scan.p_number < 10 || props.scanFilterStateV2.settings.scan.p_number === '')) {
        props.scanFilterStateV2.settings.scan.p_number = 10;
      }
    },
    {immediate: true}
);

watch(() => props.scanFilterStateV2.settings.scan.timezone, (newTimezone) => {
      if (props.scanFilterStateV2.preserveTimezone) {
        if (window.localStorage) {
          window.localStorage.setItem('cr-selected-timezone', newTimezone);
        }
      }
    },
    { deep: true }
);

watch(() =>props.scanFilterStateV2.uploads, (newUploads) => {
      if (!props.scanFilterStateV2.loadingUploads && newUploads.length > 0) {
        const newTimestamps = [];
        for (let upload of newUploads) {
          if (props.scanFilterStateV2.uploads && props.scanFilterStateV2.uploads.includes(upload.uploadId)) {
            newTimestamps.push(upload.timestamp);
          }
        }
        //@ts-ignore
        uploadTimestamps.value = newTimestamps.join(', ');
      }
    },
    { deep: true }
);

watch(() => [props.scanFilterStateV2.loadingServices, props.scanFilterStateV2.services, services.value], ([newLoading, newServices, localServices], [oldLoading, oldServices, oldLocalServices]) => {
      if (!newLoading && newServices.length > 0 && !props.scanFilterStateV2.services.select_all) {
        if (localServices !== 'all' && Array.isArray(localServices) && localServices.length > 0) {
          const newServiceNames = [];
          for (let s of newServices) {
            if (localServices.includes(s.serviceId)) {
              newServiceNames.push(s.serviceName);
            }
          }
          //@ts-ignore
          serviceNames.value = newServiceNames.join(', ');
        } else {
          serviceNames.value = [];
        }
      }
    },
    { deep: true }
);

watch(() => [props.scanFilterStateV2.loadingUsers, props.scanFilterStateV2.users, users.value], ([newLoadingUsers, newUsers, localUsers]) => {
      if (!newLoadingUsers && newUsers.length > 0) {
        if (localUsers !== 'all' && Array.isArray(localUsers) && localUsers.length > 0) {
          const newUserNames = [];
          for (let u of newUsers) {
            if (localUsers.includes(u.userId)) {
              newUserNames.push(u.username);
            }
          }
          //@ts-ignore
          userNames.value = newUserNames.join(', ');
        } else {
          userNames.value = []; // Reset if conditions not met
        }
      }
    },
    { deep: true }
);

watch(() => [props.scanFilterStateV2.loadingDevices, props.scanFilterStateV2.devices, devices.value], ([newLoadingDevices, newDevices, localDevices]) => {
      if (!newLoadingDevices && newDevices.length > 0) {
        if (localDevices !== 'all' && Array.isArray(localDevices) && localDevices.length > 0) {
          const newDeviceNames = [];
          for (let d of newDevices) {
            if (localDevices.includes(d.deviceId)) {
              newDeviceNames.push(d.deviceName);
            }
          }
          //@ts-ignore
          deviceNames.value = newDeviceNames.join(', ');
        } else {
          deviceNames.value = []; // Reset if conditions not met
        }
      }
    },
    { deep: true }
);


onMounted(() => {
  createPaginator();
});

function validateScanIds(ids) {
  props.scanFilterStateV2.showErrorForScanIds = false;
  for (let id of ids.replace(/\s/g, '').split(',')) {
    if (id !== '') {
      props.scanFilterStateV2.showErrorForScanIds = id.match(/^[0-9]+$/) === null;
    }
  }
}

function checkScanResult(value) {
  const index = scanResults.value.indexOf(value);
  if (index < 0) {
    scanResults.value.push(value);
    props.scanFilterStateV2.settings.scan.result.push(value);
  } else {
    scanResults.value.splice(index, 1);
    props.scanFilterStateV2.settings.scan.result.splice(index, 1);
  }
}

async function showScans() {
  showScansModal.value = true;
  props.scanFilterStateV2.paginator.offset = 0;
  props.scanFilterStateV2.paginator.itemsPerPage = 10;
  await props.scanFilterStateV2.loadScans();
}

async function filter(filterType) {
  if (props.scanFilterStateV2.showErrorForScanIds) {
    return  flashMessenger.toastById('REQ_PARAMS', 'danger');
  }

  let params = {};

  params[props.scanFilterStateV2.urlMapping['value']] = props.scanFilterStateV2.settings.scan.value;
  if (props.scanFilterStateV2.settings.scan.value != '') {
    params[props.scanFilterStateV2.urlMapping['exact_value']] = props.scanFilterStateV2.settings.scan.exact_value ? 'true' : 'false';
    params[props.scanFilterStateV2.urlMapping['value_ci']] = props.scanFilterStateV2.settings.scan.value_ci  ? 'true' : 'false';
  }
  params[props.scanFilterStateV2.urlMapping['response']] = props.scanFilterStateV2.settings.scan.response;
  if (props.scanFilterStateV2.settings.scan.response != '') {
    params[props.scanFilterStateV2.urlMapping['exact_response']] = props.scanFilterStateV2.settings.scan.exact_response  ? 'true' : 'false';
    params[props.scanFilterStateV2.urlMapping['response_ci']] = props.scanFilterStateV2.settings.scan.response_ci  ? 'true' : 'false';
  }

  params[props.scanFilterStateV2.urlMapping['scan_ids']] = props.scanFilterStateV2.settings.scan.selected_ids.replace(/\s/g,'');

  params[props.scanFilterStateV2.urlMapping['answer']] = props.scanFilterStateV2.settings.scan.answer;
  if (props.scanFilterStateV2.settings.scan.answer != '') {
    params[props.scanFilterStateV2.urlMapping['exact_answer']] = props.scanFilterStateV2.settings.scan.exact_answer  ? 'true' : 'false';
  }

  params[props.scanFilterStateV2.urlMapping['property_name']] = props.scanFilterStateV2.settings.scan.property_name;
  params[props.scanFilterStateV2.urlMapping['property_value']] = props.scanFilterStateV2.settings.scan.property_value;
  params[props.scanFilterStateV2.urlMapping['recent_scan']] = props.scanFilterStateV2.settings.scan.recent_scan  ? 'true' : 'false';
  params[props.scanFilterStateV2.urlMapping['table_builder_scan']] = props.scanFilterStateV2.settings.scan.table_builder_scan  ? 'true' : 'false';
  params[props.scanFilterStateV2.urlMapping['exclude_table_builder_scan']] = props.scanFilterStateV2.settings.scan.exclude_table_builder_scan  ? 'true' : 'false';
  params[props.scanFilterStateV2.urlMapping['check_in_out_scan']] = props.scanFilterStateV2.settings.scan.check_in_out_scan  ? 'true' : 'false';
  params[props.scanFilterStateV2.urlMapping['exclude_check_in_out_scan']] = props.scanFilterStateV2.settings.scan.exclude_check_in_out_scan  ? 'true' : 'false';
  params[props.scanFilterStateV2.urlMapping['data_received']] = props.scanFilterStateV2.settings.scan.data_received;

  if (props.scanFilterStateV2.settings.scan.date_from != null && props.scanFilterStateV2.settings.scan.date_from != '') {
    if (!moment.isMoment(props.scanFilterStateV2.settings.scan.date_from)) {
      let dateFrom = new Date(props.scanFilterStateV2.settings.scan.date_from);
      props.scanFilterStateV2.settings.scan.date_from =  moment().set({
        y: dateFrom.getFullYear(),
        M: dateFrom.getMonth(),
        D: dateFrom.getDate(),
        h: dateFrom.getHours(),
        m: dateFrom.getMinutes(),
        s: dateFrom.getSeconds()
      });
    }

    params[props.scanFilterStateV2.urlMapping['start_date']] = props.scanFilterStateV2.settings.scan.date_from.format('YYYY-MM-DD');
    params[props.scanFilterStateV2.urlMapping['start_time']] = props.scanFilterStateV2.settings.scan.date_from.format('HH:mm:ss');

    if (props.scanFilterStateV2.settings.scan.period != 'custom') {
      params[props.scanFilterStateV2.urlMapping['start_date']]='';
      params[props.scanFilterStateV2.urlMapping['start_time']]='';
    }
  } else {
    params[props.scanFilterStateV2.urlMapping['start_date']]='';
    params[props.scanFilterStateV2.urlMapping['start_time']]='';
  }

  if (props.scanFilterStateV2.settings.scan.date_to != null && props.scanFilterStateV2.settings.scan.date_to != '') {
    if (!moment.isMoment(props.scanFilterStateV2.settings.scan.date_to)) {
      let dateTo = new Date(props.scanFilterStateV2.settings.scan.date_to);
      props.scanFilterStateV2.settings.scan.date_to =  moment().set({
        y: dateTo.getFullYear(),
        M: dateTo.getMonth(),
        D: dateTo.getDate(),
        h: dateTo.getHours(),
        m: dateTo.getMinutes(),
        s: dateTo.getSeconds()
      });
    }

    params[props.scanFilterStateV2.urlMapping['end_date']] = props.scanFilterStateV2.settings.scan.date_to.format('YYYY-MM-DD');
    params[props.scanFilterStateV2.urlMapping['end_time']] = props.scanFilterStateV2.settings.scan.date_to.format('HH:mm:ss');
    if (props.scanFilterStateV2.settings.scan.period != 'custom') {
      params[props.scanFilterStateV2.urlMapping['end_date']]='';
      params[props.scanFilterStateV2.urlMapping['end_time']]='';
    }
  } else {
    params[props.scanFilterStateV2.urlMapping['end_date']]='';
    params[props.scanFilterStateV2.urlMapping['end_time']]='';
  }

  params[props.scanFilterStateV2.urlMapping['period']] = props.scanFilterStateV2.settings.scan.period != '' && props.scanFilterStateV2.settings.scan.period != null ? props.scanFilterStateV2.settings.scan.period : 'last_30_days';

  if (props.scanFilterStateV2.settings.scan.period == 'last') {
    params[props.scanFilterStateV2.urlMapping['p_metric']] = props.scanFilterStateV2.settings.scan.p_metric;
    params[props.scanFilterStateV2.urlMapping['p_number']] = props.scanFilterStateV2.settings.scan.p_number;
  } else if (props.scanFilterStateV2.settings.scan.period == 'older_than') {
    params[props.scanFilterStateV2.urlMapping['p_metric']] = props.scanFilterStateV2.settings.scan.p_metric;
    params[props.scanFilterStateV2.urlMapping['p_number']] = props.scanFilterStateV2.settings.scan.p_number;
  } else {
    params[props.scanFilterStateV2.urlMapping['p_metric']] = '';
    params[props.scanFilterStateV2.urlMapping['p_number']] = 1;
  }

  params[props.scanFilterStateV2.urlMapping['tz']] = props.scanFilterStateV2.settings.scan.timezone;

  if (props.scanFilterStateV2.settings.scan.sort_order == 'asc') {
    params[props.scanFilterStateV2.urlMapping['sort_order']] = 'asc';
  } else {
    params[props.scanFilterStateV2.urlMapping['sort_order']] = 'desc';
  }

  if (props.scanFilterStateV2.settings.scan.sort_by) {
    params[props.scanFilterStateV2.urlMapping['sort_by']] = props.scanFilterStateV2.settings.scan.sort_by;
  }

  if (props.scanFilterStateV2.settings.scan.category != '') {
    params[props.scanFilterStateV2.urlMapping['category']] = props.scanFilterStateV2.settings.scan.category;
  }

  if (scanResults.value.length == 3 && scanResults.value.indexOf('0') != -1  &&
      scanResults.value.indexOf('1') != -1 && scanResults.value.indexOf('-1') != -1) {
    params['result'] = 'all';
  } else {
    params[props.scanFilterStateV2.urlMapping['result']] = scanResults.value.length == 0 ? '' : scanResults.value.join(',');
  }

  params[props.scanFilterStateV2.urlMapping['u_deleted']] = props.scanFilterStateV2.settings.users.deleted ? 1 : 0;

  if (props.scanFilterStateV2.settings.scan.upload_ids.length == 0) {
    params[props.scanFilterStateV2.urlMapping['upload_ids']] = '0';
  } else {
    params[props.scanFilterStateV2.urlMapping['upload_ids']] = props.scanFilterStateV2.settings.scan.upload_ids.join(',');
  }

  if (props.scanFilterStateV2.settings.users.selected_ids.length == 0) {
    params[props.scanFilterStateV2.urlMapping['user_ids']] = '0';
  } else {
    params[props.scanFilterStateV2.urlMapping['user_ids']] = props.scanFilterStateV2.settings.users.selected_ids.join(',');

    if (props.scanFilterStateV2.settings.users.selected_ids.length == props.scanFilterStateV2.users.length) {
      params[props.scanFilterStateV2.urlMapping['user_ids']] = 'all';
    }
  }


  params[props.scanFilterStateV2.urlMapping['s_deleted']] = props.scanFilterStateV2.settings.services.deleted ? 1 : 0;

  if (props.scanFilterStateV2.settings.services.selected_ids.length == 0 && props.scanFilterStateV2.settings.services.select_all === true) {
    params[props.scanFilterStateV2.urlMapping['service_ids']] = 'all';
  } else if (props.scanFilterStateV2.settings.services.selected_ids.length == 0 && props.scanFilterStateV2.settings.services.select_all === false) {
    params[props.scanFilterStateV2.urlMapping['service_ids']] = '0';
  } else {
    params[props.scanFilterStateV2.urlMapping['service_ids']] = props.scanFilterStateV2.settings.services.selected_ids.join(',');
  }
  /*if (props.scanFilterStateV2.settings.services.selected_ids.length == 0 && props.scanFilterStateV2.settings.services.select_all === false) {
    params[props.scanFilterStateV2.urlMapping['service_ids']] = '0';
  } else {
    params[props.scanFilterStateV2.urlMapping['service_ids']] = props.scanFilterStateV2.settings.services.selected_ids.join(',');

    if (props.scanFilterStateV2.settings.services.selected_ids.length == props.scanFilterStateV2.services.length) {
      params[props.scanFilterStateV2.urlMapping['service_ids']] = 'all';
    }
  }*/

  if (props.scanFilterStateV2.settings.devices.selected_ids.length == 0) {
    params[props.scanFilterStateV2.urlMapping['device_ids']] = '0';
  } else {
    params[props.scanFilterStateV2.urlMapping['device_ids']] = props.scanFilterStateV2.settings.devices.selected_ids.join(',');

    if (props.scanFilterStateV2.settings.devices.selected_ids.length == props.scanFilterStateV2.devices.length) {
      params[props.scanFilterStateV2.urlMapping['device_ids']] = 'all';
    }
  }

  if (props.scanFilterStateV2.settings.template.show) {
    params[props.scanFilterStateV2.urlMapping['template']] = props.scanFilterStateV2.settings.template.id;
  }

  params['limit'] = props.scanFilterStateV2.countScansInPerPage;

  if (filterType == 'view') {
    return params;
  }
  params['page'] = 1;
  await router.push({ name: route.name,
    query: Object.assign(
        {},
        route.query,
        params
    )
  });
}

function getDate(date, format) {
  if (Array.isArray(date)) {
    date = date[0];
  }
  return moment(date).format(format);
}

async function removeSearchParameter(searchParams) {
  let q = {};
  for (let p of searchParams) {
    if (p == 'value') {
      q['value'] = '';
      q['exact_value'] = 'false';
      q['value_ci'] = 'false';
    } else if (p == 'response') {
      q['response'] = '';
      q['exact_response'] = 'false';
      q['response_ci'] = 'false';
    } else if (p == 'answer') {
      q['answer'] = '';
      q['exact_answer'] = 'false';
    } else if (p == 'property') {
      q['property_name'] = '';
      q['property_value'] = '';
    } else if (p == 'recent_scan') {
      q['recent_scan'] = 'false';
    } else if (p == 'start_date') {
      q['start_date'] = '';
      if (typeof route.query["start_time"] != 'undefined') {
        q['start_time'] = '';
      }
    } else if (p == 'end_date') {
      q['end_date'] = '';
      if (typeof route.query["end_time"] != 'undefined') {
        q['end_time'] = '';
      }
    } else if (p == 'period') {
      q['period'] = 'last_30_day';
    } else if (p == 'p_number') {
      q['p_number'] = 1;
    } else if (p == 'p_metric') {
      q['p_metric'] = '';
    } else if (p == 'category') {
      q['category'] = 'all';
    } else if (p == 'result') {
      q['result'] = 'all';
    } else if (p == 'd_services') {
      q['s_deleted'] = 0;
    } else if (p == 'service_ids') {
      q['service_ids'] = 'all';
    } else if (p == 'd_users') {
      q['u_deleted'] = 0;
    } else if (p == 'user_ids') {
      q['user_ids'] = 'all';
    } else if (p == 'device_ids') {
      q['device_ids'] = 'all';
    } else if (p == 'scan_ids') {
      q['scan_ids'] = '';
    } else if (p == 'uploads') {
      q['upload_ids'] = 0;
    } else if (p == 'table_builder_scan') {
      q['table_builder_scan'] = '';
    }  else if (p == 'exclude_table_builder_scan') {
      q['exclude_table_builder_scan'] = '';
    }  else if (p == 'check_in_out_scan') {
      q['check_in_out_scan'] = '';
    }  else if (p == 'exclude_check_in_out_scan') {
      q['exclude_check_in_out_scan'] = '';
    }
  }

  q['page'] = 1;

  await router.push({ name: route.name, query: Object.assign({}, route.query, q)});
}


return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_label = _resolveComponent("v-label")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_date_time_picker = _resolveComponent("date-time-picker")!
  const _component_service_selector = _resolveComponent("service-selector")!
  const _component_user_selector = _resolveComponent("user-selector")!
  const _component_device_selector = _resolveComponent("device-selector")!
  const _component_template_list = _resolveComponent("template-list")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_scan_card = _resolveComponent("scan-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_card, null, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(_component_v_card_title, { class: "bg-grey-lighten-3 mb-3 border-b" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.scanFilterStateV2['settings']['filterTitle']), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 512 /* NEED_PATCH */), [
          [_vShow, __props.scanFilterStateV2.settings.filterTitle != '']
        ]),
        _createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [
            (!props.scanFilterStateV2.isLoading && displayFilters.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  (showScansStartDate.value != '' && showScansEndDate.value != '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createElementVNode("span", _hoisted_4, [
                          _createVNode(_component_v_icon, { icon: "mdi-clock" }),
                          _createTextVNode(),
                          _hoisted_5,
                          _createTextVNode(" " + _toDisplayString(getDate(showScansStartDate.value, 'MMM DD, YYYY h:mm A')), 1 /* TEXT */),
                          _hoisted_6,
                          _hoisted_7,
                          _createTextVNode(" " + _toDisplayString(getDate(showScansEndDate.value, 'MMM DD, YYYY h:mm A')) + " ", 1 /* TEXT */),
                          _createVNode(_component_v_icon, {
                            icon: "mdi-close",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (removeSearchParameter(['period', 'p_number', 'p_metric'])))
                          })
                        ])
                      ]))
                    : _createCommentVNode("v-if", true),
                  (scanStartDate.value != '' && scanEndDate.value == '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("span", _hoisted_9, [
                          _createVNode(_component_v_icon, { icon: "mdi-clock" }),
                          _createTextVNode(),
                          _hoisted_10,
                          _createTextVNode(" " + _toDisplayString(getDate(scanDateFrom.value, 'MMM DD, YYYY h:mm A')) + " ", 1 /* TEXT */),
                          _createVNode(_component_v_icon, {
                            icon: "mdi-close",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (removeSearchParameter(['start_date'])))
                          })
                        ])
                      ]))
                    : _createCommentVNode("v-if", true),
                  (scanStartDate.value == '' && scanEndDate.value != '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createElementVNode("span", _hoisted_12, [
                          _createVNode(_component_v_icon, { icon: "mdi-clock" }),
                          _createTextVNode(),
                          _hoisted_13,
                          _createTextVNode(" " + _toDisplayString(getDate(scanDateTo.value, 'MMM DD, YYYY h:mm A')) + " ", 1 /* TEXT */),
                          _createVNode(_component_v_icon, {
                            icon: "mdi-close",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (removeSearchParameter(['end_date'])))
                          })
                        ])
                      ]))
                    : _createCommentVNode("v-if", true),
                  (scanStartDate.value != '' && scanEndDate.value!= '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createElementVNode("span", _hoisted_15, [
                          _createVNode(_component_v_icon, { icon: "mdi-clock" }),
                          _createTextVNode(),
                          _hoisted_16,
                          _createTextVNode(" " + _toDisplayString(getDate(scanDateFrom.value, 'MMM DD, YYYY h:mm A')) + " ", 1 /* TEXT */),
                          _hoisted_17,
                          _createTextVNode(" " + _toDisplayString(getDate(scanDateTo.value, 'MMM DD, YYYY h:mm A')) + " ", 1 /* TEXT */),
                          _createVNode(_component_v_icon, {
                            icon: "mdi-close",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (removeSearchParameter(['start_date', 'end_date'])))
                          })
                        ])
                      ]))
                    : _createCommentVNode("v-if", true),
                  (scanClone.value.value != '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _createElementVNode("span", _hoisted_19, [
                          _createVNode(_component_v_icon, { icon: "mdi-magnify" }),
                          _createTextVNode(),
                          _hoisted_20,
                          _createTextVNode(" " + _toDisplayString(scanClone.value.value.length > 150 && !showValueMore.value ? scanClone.value.value.slice(0, 149) + '...' : scanClone.value.value) + " ", 1 /* TEXT */),
                          (scanClone.value.value.length > 150)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                                _createTextVNode(" ("),
                                _createElementVNode("u", {
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => (showValueMore.value = !showValueMore.value))
                                }, [
                                  _withDirectives(_createElementVNode("u", null, "show more", 512 /* NEED_PATCH */), [
                                    [_vShow, !showValueMore.value]
                                  ]),
                                  _withDirectives(_createElementVNode("u", null, "show less", 512 /* NEED_PATCH */), [
                                    [_vShow, showValueMore.value]
                                  ])
                                ]),
                                _createTextVNode(") ")
                              ]))
                            : _createCommentVNode("v-if", true),
                          _createTextVNode(),
                          _createVNode(_component_v_icon, {
                            icon: "mdi-close",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (removeSearchParameter(['value'])))
                          })
                        ])
                      ]))
                    : _createCommentVNode("v-if", true),
                  (scanClone.value.response != '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _createElementVNode("span", _hoisted_23, [
                          _createVNode(_component_v_icon, { icon: "mdi-magnify" }),
                          _createTextVNode(),
                          _hoisted_24,
                          _createTextVNode(" " + _toDisplayString(scanClone.value.response.length > 150 && !showResponseMore.value ? scanClone.value.response.slice(0, 149) + '...' : scanClone.value.response) + " ", 1 /* TEXT */),
                          (scanClone.value.response.length > 150)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_25, [
                                _createTextVNode(" ("),
                                _createElementVNode("u", {
                                  onClick: _cache[6] || (_cache[6] = ($event: any) => (showResponseMore.value = !showResponseMore.value))
                                }, [
                                  _withDirectives(_createElementVNode("u", null, "show more", 512 /* NEED_PATCH */), [
                                    [_vShow, !showResponseMore.value]
                                  ]),
                                  _withDirectives(_createElementVNode("u", null, "show less", 512 /* NEED_PATCH */), [
                                    [_vShow, showResponseMore.value]
                                  ])
                                ]),
                                _createTextVNode(") ")
                              ]))
                            : _createCommentVNode("v-if", true),
                          _createTextVNode(),
                          _createVNode(_component_v_icon, {
                            icon: "mdi-close",
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (removeSearchParameter(['response'])))
                          })
                        ])
                      ]))
                    : _createCommentVNode("v-if", true),
                  (scanClone.value.property_name != '' && scanClone.value.property_value != '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        _createElementVNode("span", _hoisted_27, [
                          _createVNode(_component_v_icon, { icon: "mdi-magnify" }),
                          _hoisted_28,
                          _hoisted_29,
                          _createTextVNode(" - " + _toDisplayString(scanClone.value['property_name'].length > 100 && !showPropertyName.value ? scanClone.value['property_name'].slice(0, 99) + '...' : scanClone.value['property_name']) + " ", 1 /* TEXT */),
                          _withDirectives(_createElementVNode("span", _hoisted_30, [
                            _createTextVNode(" ("),
                            _createElementVNode("u", {
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (showPropertyName.value = !showPropertyName.value))
                            }, [
                              _withDirectives(_createElementVNode("u", null, "show more", 512 /* NEED_PATCH */), [
                                [_vShow, !showPropertyName.value]
                              ]),
                              _withDirectives(_createElementVNode("u", null, "show less", 512 /* NEED_PATCH */), [
                                [_vShow, showPropertyName.value]
                              ])
                            ]),
                            _createTextVNode(") ")
                          ], 512 /* NEED_PATCH */), [
                            [_vShow, scanClone.value.property_name.length > 100]
                          ]),
                          _createTextVNode("  "),
                          _hoisted_31,
                          _createTextVNode(" - " + _toDisplayString(scanClone.value['property_value'].length > 100 && !showPropertyValue.value ? scanClone.value['property_value'].slice(0, 99) + '...' : scanClone.value['property_value']) + " ", 1 /* TEXT */),
                          _withDirectives(_createElementVNode("span", _hoisted_32, [
                            _createTextVNode(" ("),
                            _createElementVNode("u", {
                              onClick: _cache[9] || (_cache[9] = ($event: any) => (showPropertyValue.value = !showPropertyValue.value))
                            }, [
                              _withDirectives(_createElementVNode("u", null, "show more", 512 /* NEED_PATCH */), [
                                [_vShow, !showPropertyValue.value]
                              ]),
                              _withDirectives(_createElementVNode("u", null, "show less", 512 /* NEED_PATCH */), [
                                [_vShow, showPropertyValue.value]
                              ])
                            ]),
                            _createTextVNode(") ")
                          ], 512 /* NEED_PATCH */), [
                            [_vShow, scanClone.value.property_value.length > 100]
                          ]),
                          _createTextVNode(),
                          _createVNode(_component_v_icon, {
                            icon: "mdi-close",
                            onClick: _cache[10] || (_cache[10] = ($event: any) => (removeSearchParameter(['property'])))
                          })
                        ])
                      ]))
                    : _createCommentVNode("v-if", true),
                  (scanClone.value.property_name != '' && scanClone.value.property_value != '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                        _createElementVNode("span", _hoisted_34, [
                          _createVNode(_component_v_icon, { icon: "mdi-help" }),
                          _hoisted_35,
                          _createTextVNode(" " + _toDisplayString(scanClone.value['answer'].length > 150 && !showAnswerMore.value ? scanClone.value['answer'].slice(0, 149) + '...' : scanClone.value['answer']) + " ", 1 /* TEXT */),
                          _withDirectives(_createElementVNode("span", _hoisted_36, [
                            _createTextVNode(" ("),
                            _createElementVNode("u", {
                              onClick: _cache[11] || (_cache[11] = ($event: any) => (showAnswerMore.value = !showAnswerMore.value))
                            }, [
                              _withDirectives(_createElementVNode("u", null, "show more", 512 /* NEED_PATCH */), [
                                [_vShow, !showAnswerMore.value]
                              ]),
                              _withDirectives(_createElementVNode("u", null, "show less", 512 /* NEED_PATCH */), [
                                [_vShow, showAnswerMore.value]
                              ])
                            ]),
                            _createTextVNode(") ")
                          ], 512 /* NEED_PATCH */), [
                            [_vShow, scanClone.value.answer.length > 150]
                          ]),
                          _createTextVNode(),
                          _createVNode(_component_v_icon, {
                            icon: "mdi-close",
                            onClick: _cache[12] || (_cache[12] = ($event: any) => (removeSearchParameter(['answer'])))
                          })
                        ])
                      ]))
                    : _createCommentVNode("v-if", true),
                  (scanClone.value.recent_scan)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                        _createElementVNode("span", _hoisted_38, [
                          _createTextVNode(_toDisplayString(scanClone.value.recent_scan ? 'Recent Scan' : '') + " ", 1 /* TEXT */),
                          _createVNode(_component_v_icon, {
                            icon: "mdi-close",
                            onClick: _cache[13] || (_cache[13] = ($event: any) => (removeSearchParameter(['recent_scan'])))
                          })
                        ])
                      ]))
                    : _createCommentVNode("v-if", true),
                  (scanClone.value.table_builder_scan)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                        _createElementVNode("span", _hoisted_40, [
                          _createTextVNode(_toDisplayString(scanClone.value.table_builder_scan ? 'Only active Table Builder records' : '') + " ", 1 /* TEXT */),
                          _createVNode(_component_v_icon, {
                            icon: "mdi-close",
                            onClick: _cache[14] || (_cache[14] = ($event: any) => (removeSearchParameter(['table_builder_scan'])))
                          })
                        ])
                      ]))
                    : _createCommentVNode("v-if", true),
                  (scanClone.value.exclude_table_builder_scan)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                        _createElementVNode("span", _hoisted_42, [
                          _createTextVNode(_toDisplayString(scanClone.value.exclude_table_builder_scan ? 'Exclude Table Builder records' : '') + " ", 1 /* TEXT */),
                          _createVNode(_component_v_icon, {
                            icon: "mdi-close",
                            onClick: _cache[15] || (_cache[15] = ($event: any) => (removeSearchParameter(['exclude_table_builder_scan'])))
                          })
                        ])
                      ]))
                    : _createCommentVNode("v-if", true),
                  (scanClone.value.check_in_out_scan)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                        _createElementVNode("span", _hoisted_44, [
                          _createTextVNode(_toDisplayString(scanClone.value.check_in_out_scan ? 'Only active Check IN/OUT records' : '') + " ", 1 /* TEXT */),
                          _createVNode(_component_v_icon, {
                            icon: "mdi-close",
                            onClick: _cache[16] || (_cache[16] = ($event: any) => (removeSearchParameter(['check_in_out_scan'])))
                          })
                        ])
                      ]))
                    : _createCommentVNode("v-if", true),
                  (scanClone.value.exclude_check_in_out_scan)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                        _createElementVNode("span", _hoisted_46, [
                          _createTextVNode(_toDisplayString(scanClone.value.exclude_check_in_out_scan ? 'Exclude Check IN/OUT records' : '') + " ", 1 /* TEXT */),
                          _createVNode(_component_v_icon, {
                            icon: "mdi-close",
                            onClick: _cache[17] || (_cache[17] = ($event: any) => (removeSearchParameter(['exclude_check_in_out_scan'])))
                          })
                        ])
                      ]))
                    : _createCommentVNode("v-if", true),
                  (scanClone.value.category != 'all')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                        _createElementVNode("span", _hoisted_48, [
                          _createTextVNode(_toDisplayString(scanClone.value.category == 'real_time' ? 'Real-time Scans' : 'Uploaded Scans') + " ", 1 /* TEXT */),
                          _createVNode(_component_v_icon, {
                            icon: "mdi-close",
                            onClick: _cache[18] || (_cache[18] = ($event: any) => (removeSearchParameter(['category'])))
                          })
                        ])
                      ]))
                    : _createCommentVNode("v-if", true),
                  (scanClone.value.selected_ids != '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                        _createElementVNode("span", _hoisted_50, [
                          _hoisted_51,
                          _createTextVNode(" " + _toDisplayString(scanClone.value['selected_ids']) + " ", 1 /* TEXT */),
                          _createVNode(_component_v_icon, {
                            icon: "mdi-close",
                            onClick: _cache[19] || (_cache[19] = ($event: any) => (removeSearchParameter(['scan_ids'])))
                          })
                        ])
                      ]))
                    : _createCommentVNode("v-if", true),
                  (scanClone.value.result != 'all' && scanClone.value.result.length != 3 && scanClone.value.result.length != 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                        _createElementVNode("span", _hoisted_53, [
                          (scanClone.value.result.indexOf('0') != -1 &&  scanClone.value.result.length == 1)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_54, [
                                _createElementVNode("img", {
                                  src: _unref(asset)('icon/invalid-small.png'),
                                  alt: "invalid icon"
                                }, null, 8 /* PROPS */, _hoisted_55),
                                _createTextVNode(" Only Invalid Scans   ")
                              ]))
                            : _createCommentVNode("v-if", true),
                          (scanClone.value.result.indexOf('1') != -1 &&  scanClone.value.result.length == 1)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_56, [
                                _createElementVNode("img", {
                                  src: _unref(asset)('icon/valid-small.png'),
                                  alt: "valid icon"
                                }, null, 8 /* PROPS */, _hoisted_57),
                                _createTextVNode(" Only Valid Scans   ")
                              ]))
                            : _createCommentVNode("v-if", true),
                          (scanClone.value.result.indexOf('-1') != -1 &&  scanClone.value.result.length == 1)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_58, [
                                _createElementVNode("img", {
                                  src: _unref(asset)('icon/saved-small.png'),
                                  alt: "saved icon"
                                }, null, 8 /* PROPS */, _hoisted_59),
                                _createTextVNode(" Only Saved Scans   ")
                              ]))
                            : _createCommentVNode("v-if", true),
                          (scanClone.value.result.indexOf('1') != -1 &&  scanClone.value.result.indexOf('-1') != -1 && scanClone.value.result.length == 2)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_60, [
                                _createElementVNode("img", {
                                  src: _unref(asset)('icon/valid-small.png'),
                                  alt: "valid icon"
                                }, null, 8 /* PROPS */, _hoisted_61),
                                _createElementVNode("img", {
                                  src: _unref(asset)('icon/saved-small.png'),
                                  alt: "saved icon"
                                }, null, 8 /* PROPS */, _hoisted_62),
                                _createTextVNode(" Only Valid and Saved Scans   ")
                              ]))
                            : _createCommentVNode("v-if", true),
                          (scanClone.value.result.indexOf('1') != -1 &&  scanClone.value.result.indexOf('0') != -1 && scanClone.value.result.length == 2)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_63, [
                                _createElementVNode("img", {
                                  src: _unref(asset)('icon/valid-small.png'),
                                  alt: "valid icon"
                                }, null, 8 /* PROPS */, _hoisted_64),
                                _createElementVNode("img", {
                                  src: _unref(asset)('icon/invalid-small.png'),
                                  alt: "invalid icon"
                                }, null, 8 /* PROPS */, _hoisted_65),
                                _createTextVNode(" Only Valid and Invalid Scans   ")
                              ]))
                            : _createCommentVNode("v-if", true),
                          (scanClone.value.result.indexOf('0') != -1 &&  scanClone.value.result.indexOf('-1') != -1 && scanClone.value.result.length == 2)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_66, [
                                _createElementVNode("img", {
                                  src: _unref(asset)('icon/invalid-small.png'),
                                  alt: "invalid icon"
                                }, null, 8 /* PROPS */, _hoisted_67),
                                _createElementVNode("img", {
                                  src: _unref(asset)('icon/saved-small.png'),
                                  alt: "saved icon"
                                }, null, 8 /* PROPS */, _hoisted_68),
                                _createTextVNode(" Only Invalid and Saved Scans   ")
                              ]))
                            : _createCommentVNode("v-if", true),
                          _createTextVNode(),
                          _createVNode(_component_v_icon, {
                            icon: "mdi-close",
                            onClick: _cache[20] || (_cache[20] = ($event: any) => (removeSearchParameter(['result'])))
                          })
                        ])
                      ]))
                    : _createCommentVNode("v-if", true),
                  (uploads.value.length > 0 )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                        _createElementVNode("span", _hoisted_70, [
                          _createVNode(_component_v_icon, { icon: "mdi-upload-box-outline" }),
                          _createTextVNode(),
                          _hoisted_71,
                          _createTextVNode(),
                          (uploadTimestamps.value)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(" on " + _toDisplayString(getDate(uploadTimestamps.value, 'MMM DD, YYYY h:mm A')), 1 /* TEXT */)
                              ], 64 /* STABLE_FRAGMENT */))
                            : _createCommentVNode("v-if", true),
                          _createTextVNode(),
                          _createVNode(_component_v_icon, {
                            icon: "mdi-close",
                            onClick: _cache[21] || (_cache[21] = ($event: any) => (removeSearchParameter(['uploads'])))
                          })
                        ])
                      ]))
                    : _createCommentVNode("v-if", true),
                  (!__props.scanFilterStateV2.settings.services.select_all && services.value.length == 0 && deletedServices.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                        _createElementVNode("span", _hoisted_73, [
                          _createVNode(_component_v_icon, { icon: "mdi-file" }),
                          _createTextVNode(" Only Deleted Services "),
                          _createVNode(_component_v_icon, {
                            icon: "mdi-close",
                            onClick: _cache[22] || (_cache[22] = ($event: any) => (removeSearchParameter(['d_services'])))
                          })
                        ])
                      ]))
                    : _createCommentVNode("v-if", true),
                  (!__props.scanFilterStateV2.settings.users.select_all && users.value.length == 0 && deletedUsers.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                        _createElementVNode("span", _hoisted_75, [
                          _createVNode(_component_v_icon, { icon: "mdi-account" }),
                          _createTextVNode(" Only Deleted Users "),
                          _createVNode(_component_v_icon, {
                            icon: "mdi-close",
                            onClick: _cache[23] || (_cache[23] = ($event: any) => (removeSearchParameter(['d_users'])))
                          })
                        ])
                      ]))
                    : _createCommentVNode("v-if", true),
                  (serviceNames.value.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                        _createElementVNode("span", _hoisted_77, [
                          _createVNode(_component_v_icon, { icon: "mdi-file" }),
                          _createTextVNode(),
                          _hoisted_78,
                          _createTextVNode(" " + _toDisplayString(serviceNames.value) + " " + _toDisplayString(deletedServices.value ? ', All Deleted Services' : '') + " ", 1 /* TEXT */),
                          _createVNode(_component_v_icon, {
                            icon: "mdi-close",
                            onClick: _cache[24] || (_cache[24] = ($event: any) => (removeSearchParameter(deletedServices.value ? ['service_ids', 'd_services'] : ['service_ids'])))
                          })
                        ])
                      ]))
                    : _createCommentVNode("v-if", true),
                  (userNames.value.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                        _createElementVNode("span", _hoisted_80, [
                          _createVNode(_component_v_icon, { icon: "mdi-account" }),
                          _createTextVNode(),
                          _hoisted_81,
                          _createTextVNode(" " + _toDisplayString(userNames.value) + " " + _toDisplayString(deletedUsers.value ? ', All Deleted Users' : '') + " ", 1 /* TEXT */),
                          _createVNode(_component_v_icon, {
                            icon: "mdi-close",
                            onClick: _cache[25] || (_cache[25] = ($event: any) => (removeSearchParameter(deletedUsers.value ? ['user_ids', 'd_users'] : ['user_ids'])))
                          })
                        ])
                      ]))
                    : _createCommentVNode("v-if", true),
                  (deviceNames.value.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                        _createElementVNode("span", _hoisted_83, [
                          _createVNode(_component_v_icon, { icon: "mdi-cellphone-sound" }),
                          _createTextVNode(),
                          _hoisted_84,
                          _createTextVNode(" " + _toDisplayString(deviceNames.value) + " ", 1 /* TEXT */),
                          _createVNode(_component_v_icon, {
                            icon: "mdi-close",
                            onClick: _cache[26] || (_cache[26] = ($event: any) => (removeSearchParameter(['device_ids'])))
                          })
                        ])
                      ]))
                    : _createCommentVNode("v-if", true)
                ]))
              : _createCommentVNode("v-if", true),
            _createVNode(_component_v_divider, { class: "border-opacity-50 mt-2 mb-2" }),
            _createVNode(_component_v_form, {
              onSubmit: _withModifiers(filter, ["prevent"]),
              class: "mt-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_expansion_panels, {
                  modelValue: panel.value,
                  "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((panel).value = $event)),
                  variant: "accordion",
                  multiple: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_expansion_panel, {
                      class: _normalizeClass({ 'bg-grey-lighten-4 my-1': panel.value.includes(0) }),
                      elevation: "0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_expansion_panel_title, {
                          class: "font-weight-bold px-0 my-n3 text-body-2",
                          "hide-actions": ""
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_85, [
                              _createVNode(_component_v_icon, {
                                class: "mt-n1",
                                size: "x-large",
                                icon: panel.value.includes(0) ? 'mdi-menu-down' : 'mdi-menu-right'
                              }, null, 8 /* PROPS */, ["icon"]),
                              _createTextVNode(),
                              _createVNode(_component_v_icon, { icon: "mdi-magnify" }),
                              _createTextVNode("Search Options ")
                            ])
                          ]),
                          _: 1 /* STABLE */
                        }),
                        _createVNode(_component_v_expansion_panel_text, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", null, [
                              _hoisted_86,
                              _createVNode(_component_v_text_field, {
                                variant: "outlined",
                                placeholder: "Barcode Value",
                                modelValue: __props.scanFilterStateV2.settings.scan.value,
                                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((__props.scanFilterStateV2.settings.scan.value) = $event)),
                                density: "compact",
                                "hide-details": ""
                              }, null, 8 /* PROPS */, ["modelValue"]),
                              _createVNode(_component_v_row, { "no-gutters": "" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { cols: "6" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_checkbox, {
                                        modelValue: __props.scanFilterStateV2.settings.scan.exact_value,
                                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((__props.scanFilterStateV2.settings.scan.exact_value) = $event)),
                                        label: "Exact Phrase",
                                        density: "compact",
                                        "hide-details": ""
                                      }, null, 8 /* PROPS */, ["modelValue"])
                                    ]),
                                    _: 1 /* STABLE */
                                  }),
                                  _createVNode(_component_v_col, { cols: "6" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_checkbox, {
                                        modelValue: __props.scanFilterStateV2.settings.scan.value_ci,
                                        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((__props.scanFilterStateV2.settings.scan.value_ci) = $event)),
                                        label: "Case Insensitive",
                                        density: "compact",
                                        "hide-details": ""
                                      }, null, 8 /* PROPS */, ["modelValue"])
                                    ]),
                                    _: 1 /* STABLE */
                                  })
                                ]),
                                _: 1 /* STABLE */
                              })
                            ]),
                            _createElementVNode("div", _hoisted_87, [
                              _hoisted_88,
                              _createVNode(_component_v_text_field, {
                                variant: "outlined",
                                placeholder: "Search Response",
                                modelValue: __props.scanFilterStateV2.settings.scan.response,
                                "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((__props.scanFilterStateV2.settings.scan.response) = $event)),
                                density: "compact",
                                "hide-details": ""
                              }, null, 8 /* PROPS */, ["modelValue"]),
                              _createVNode(_component_v_row, { "no-gutters": "" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { cols: "6" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_checkbox, {
                                        modelValue: __props.scanFilterStateV2.settings.scan.exact_response,
                                        "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((__props.scanFilterStateV2.settings.scan.exact_response) = $event)),
                                        label: "Exact Phrase",
                                        density: "compact"
                                      }, null, 8 /* PROPS */, ["modelValue"])
                                    ]),
                                    _: 1 /* STABLE */
                                  }),
                                  _createVNode(_component_v_col, { cols: "6" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_checkbox, {
                                        modelValue: __props.scanFilterStateV2.settings.scan.response_ci,
                                        "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((__props.scanFilterStateV2.settings.scan.response_ci) = $event)),
                                        label: "Case Insensitive",
                                        density: "compact"
                                      }, null, 8 /* PROPS */, ["modelValue"])
                                    ]),
                                    _: 1 /* STABLE */
                                  })
                                ]),
                                _: 1 /* STABLE */
                              })
                            ]),
                            (__props.scanFilterStateV2.showAnswersAndPropertyInputs)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                                  _createElementVNode("div", null, [
                                    _hoisted_90,
                                    _createVNode(_component_v_text_field, {
                                      variant: "outlined",
                                      placeholder: "Search Answers",
                                      modelValue: __props.scanFilterStateV2.settings.scan.answer,
                                      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((__props.scanFilterStateV2.settings.scan.answer) = $event)),
                                      density: "compact",
                                      "hide-details": ""
                                    }, null, 8 /* PROPS */, ["modelValue"]),
                                    _createVNode(_component_v_checkbox, {
                                      modelValue: __props.scanFilterStateV2.settings.scan.exact_answer,
                                      "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((__props.scanFilterStateV2.settings.scan.exact_answer) = $event)),
                                      label: "Exact Phrase",
                                      density: "compact"
                                    }, null, 8 /* PROPS */, ["modelValue"])
                                  ]),
                                  _createVNode(_component_v_label, { class: "d-block mb-2" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Search Property")
                                    ]),
                                    _: 1 /* STABLE */
                                  }),
                                  _createVNode(_component_v_text_field, {
                                    variant: "outlined",
                                    label: "Name",
                                    modelValue: __props.scanFilterStateV2.settings.scan.property_name,
                                    "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((__props.scanFilterStateV2.settings.scan.property_name) = $event)),
                                    density: "compact"
                                  }, null, 8 /* PROPS */, ["modelValue"]),
                                  _createVNode(_component_v_text_field, {
                                    variant: "outlined",
                                    label: "Value",
                                    modelValue: __props.scanFilterStateV2.settings.scan.property_value,
                                    "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((__props.scanFilterStateV2.settings.scan.property_value) = $event)),
                                    density: "compact"
                                  }, null, 8 /* PROPS */, ["modelValue"])
                                ]))
                              : _createCommentVNode("v-if", true),
                            _createElementVNode("div", {
                              class: _normalizeClass({'has-error': __props.scanFilterStateV2.showErrorForScanIds == true})
                            }, [
                              _hoisted_91,
                              _createVNode(_component_v_text_field, {
                                variant: "outlined",
                                placeholder: "Scan Ids",
                                modelValue: __props.scanFilterStateV2.settings.scan.selected_ids,
                                "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((__props.scanFilterStateV2.settings.scan.selected_ids) = $event)),
                                density: "compact",
                                onChange: _cache[38] || (_cache[38] = ($event: any) => (validateScanIds(__props.scanFilterStateV2.settings.scan.selected_ids))),
                                "hide-details": ""
                              }, null, 8 /* PROPS */, ["modelValue"]),
                              _hoisted_92
                            ], 2 /* CLASS */),
                            _createVNode(_component_v_checkbox, {
                              modelValue: __props.scanFilterStateV2.settings.scan.recent_scan,
                              "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((__props.scanFilterStateV2.settings.scan.recent_scan) = $event)),
                              label: "Only recent scan for each barcode",
                              density: "compact",
                              class: "mt-5",
                              "hide-details": ""
                            }, null, 8 /* PROPS */, ["modelValue"]),
                            _createVNode(_component_v_checkbox, {
                              modelValue: __props.scanFilterStateV2.settings.scan.table_builder_scan,
                              "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((__props.scanFilterStateV2.settings.scan.table_builder_scan) = $event)),
                              disabled: __props.scanFilterStateV2.settings.scan.exclude_table_builder_scan,
                              label: "Only active Table Builder records",
                              density: "compact",
                              "hide-details": ""
                            }, null, 8 /* PROPS */, ["modelValue", "disabled"]),
                            _createVNode(_component_v_checkbox, {
                              modelValue: __props.scanFilterStateV2.settings.scan.exclude_table_builder_scan,
                              "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((__props.scanFilterStateV2.settings.scan.exclude_table_builder_scan) = $event)),
                              disabled: __props.scanFilterStateV2.settings.scan.table_builder_scan,
                              label: "Exclude Table Builder records",
                              density: "compact",
                              "hide-details": ""
                            }, null, 8 /* PROPS */, ["modelValue", "disabled"]),
                            _createVNode(_component_v_checkbox, {
                              modelValue: __props.scanFilterStateV2.settings.scan.check_in_out_scan,
                              "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((__props.scanFilterStateV2.settings.scan.check_in_out_scan) = $event)),
                              disabled: __props.scanFilterStateV2.settings.scan.exclude_check_in_out_scan,
                              label: "Only active Check IN/OUT records",
                              density: "compact",
                              "hide-details": ""
                            }, null, 8 /* PROPS */, ["modelValue", "disabled"]),
                            _createVNode(_component_v_checkbox, {
                              modelValue: __props.scanFilterStateV2.settings.scan.exclude_check_in_out_scan,
                              "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((__props.scanFilterStateV2.settings.scan.exclude_check_in_out_scan) = $event)),
                              disabled: __props.scanFilterStateV2.settings.scan.check_in_out_scan,
                              label: "Exclude Check IN/OUT records",
                              density: "compact",
                              "hide-details": ""
                            }, null, 8 /* PROPS */, ["modelValue", "disabled"])
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["class"]),
                    _createVNode(_component_v_expansion_panel, {
                      class: _normalizeClass({ 'bg-grey-lighten-4 my-1': panel.value.includes(1) }),
                      elevation: "0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_expansion_panel_title, {
                          class: "font-weight-bold px-0 my-n3 text-body-2",
                          "hide-actions": ""
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_93, [
                              _createVNode(_component_v_icon, {
                                class: "mt-n1",
                                size: "x-large",
                                icon: panel.value.includes(1) ? 'mdi-menu-down' : 'mdi-menu-right'
                              }, null, 8 /* PROPS */, ["icon"]),
                              _createTextVNode(),
                              _createVNode(_component_v_icon, { icon: "mdi-calendar-today" }),
                              _createTextVNode(" Date and Order ")
                            ])
                          ]),
                          _: 1 /* STABLE */
                        }),
                        _createVNode(_component_v_expansion_panel_text, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_radio_group, {
                              modelValue: __props.scanFilterStateV2.settings.scan.data_received,
                              "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((__props.scanFilterStateV2.settings.scan.data_received) = $event)),
                              class: "mt-3"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_radio, {
                                  label: "Date Scanned",
                                  value: 0,
                                  density: "compact"
                                }),
                                _createVNode(_component_v_radio, {
                                  label: "Date Received",
                                  value: 1,
                                  density: "compact"
                                }),
                                _createVNode(_component_v_radio, {
                                  label: "Date Modified",
                                  value: 2,
                                  density: "compact"
                                }),
                                _createVNode(_component_v_radio, {
                                  label: "Date modified and received",
                                  value: "3",
                                  density: "compact"
                                })
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["modelValue"]),
                            _createVNode(_component_v_row, { "no-gutters": "" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  sm: "4"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Date Range")
                                  ]),
                                  _: 1 /* STABLE */
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  sm: "8"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_select, {
                                      variant: "outlined",
                                      modelValue: __props.scanFilterStateV2.settings.scan.period,
                                      "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((__props.scanFilterStateV2.settings.scan.period) = $event)),
                                      items: Object.entries(__props.scanFilterStateV2.periods).map(([value, title]) => ({ value, title })),
                                      density: "compact"
                                    }, null, 8 /* PROPS */, ["modelValue", "items"])
                                  ]),
                                  _: 1 /* STABLE */
                                }),
                                (__props.scanFilterStateV2.settings.scan.period == 'custom')
                                  ? (_openBlock(), _createBlock(_component_v_col, {
                                      key: 0,
                                      cols: "12"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_row, { "no-gutters": "" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, {
                                              cols: "12",
                                              sm: "2"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("From")
                                              ]),
                                              _: 1 /* STABLE */
                                            }),
                                            _createVNode(_component_v_col, {
                                              class: "mb-4",
                                              cols: "12",
                                              sm: "10"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_date_time_picker, {
                                                  "date-time": __props.scanFilterStateV2.settings.scan.date_from,
                                                  "onUpdate:dateTime": _cache[46] || (_cache[46] = ($event: any) => ((__props.scanFilterStateV2.settings.scan.date_from) = $event)),
                                                  selected: __props.scanFilterStateV2.settings.scan.date_from,
                                                  label: "From",
                                                  format: "MM/DD/YYYY hh:mm a"
                                                }, null, 8 /* PROPS */, ["date-time", "selected"])
                                              ]),
                                              _: 1 /* STABLE */
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "12",
                                              sm: "2"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("To")
                                              ]),
                                              _: 1 /* STABLE */
                                            }),
                                            _createVNode(_component_v_col, {
                                              class: "mb-4",
                                              col: "12",
                                              sm: "10"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_date_time_picker, {
                                                  "date-time": __props.scanFilterStateV2.settings.scan.date_to,
                                                  "onUpdate:dateTime": _cache[47] || (_cache[47] = ($event: any) => ((__props.scanFilterStateV2.settings.scan.date_to) = $event)),
                                                  selected: __props.scanFilterStateV2.settings.scan.date_to,
                                                  label: "To",
                                                  format: "MM/DD/YYYY hh:mm a"
                                                }, null, 8 /* PROPS */, ["date-time", "selected"])
                                              ]),
                                              _: 1 /* STABLE */
                                            })
                                          ]),
                                          _: 1 /* STABLE */
                                        })
                                      ]),
                                      _: 1 /* STABLE */
                                    }))
                                  : _createCommentVNode("v-if", true),
                                (['last', 'older_than'].includes(__props.scanFilterStateV2.settings.scan.period))
                                  ? (_openBlock(), _createBlock(_component_v_col, {
                                      key: 1,
                                      cols: "12"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_row, { "no-gutters": "" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, {
                                              cols: "12",
                                              sm: "4"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(__props.scanFilterStateV2.settings.scan.period === 'last' ? 'Last' : 'Older Than'), 1 /* TEXT */)
                                              ]),
                                              _: 1 /* STABLE */
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "12",
                                              sm: "3"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_text_field, {
                                                  variant: "outlined",
                                                  type: "number",
                                                  class: "mr-1",
                                                  density: "compact",
                                                  min: "1",
                                                  modelValue: __props.scanFilterStateV2.settings.scan.p_number,
                                                  "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((__props.scanFilterStateV2.settings.scan.p_number) = $event))
                                                }, null, 8 /* PROPS */, ["modelValue"])
                                              ]),
                                              _: 1 /* STABLE */
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "12",
                                              sm: "5"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_select, {
                                                  variant: "outlined",
                                                  modelValue: __props.scanFilterStateV2.settings.scan.p_metric,
                                                  "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((__props.scanFilterStateV2.settings.scan.p_metric) = $event)),
                                                  items: Object.entries(__props.scanFilterStateV2.metrics).map(([value, title]) => ({ value, title })),
                                                  density: "compact"
                                                }, null, 8 /* PROPS */, ["modelValue", "items"])
                                              ]),
                                              _: 1 /* STABLE */
                                            })
                                          ]),
                                          _: 1 /* STABLE */
                                        })
                                      ]),
                                      _: 1 /* STABLE */
                                    }))
                                  : _createCommentVNode("v-if", true),
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  sm: "4"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Timezone")
                                  ]),
                                  _: 1 /* STABLE */
                                }),
                                _createVNode(_component_v_col, {
                                  class: "mb-4",
                                  cols: "12",
                                  sm: "8"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(TimezoneListComponent, {
                                      label: "Timezone",
                                      value: __props.scanFilterStateV2.settings.scan.timezone,
                                      "onUpdate:value": _cache[50] || (_cache[50] = ($event: any) => ((__props.scanFilterStateV2.settings.scan.timezone) = $event)),
                                      "timezone-mode": __props.scanFilterStateV2.settings.scan.timezone_mode,
                                      "preserve-timezone": __props.scanFilterStateV2.preserveTimezone
                                    }, null, 8 /* PROPS */, ["value", "timezone-mode", "preserve-timezone"])
                                  ]),
                                  _: 1 /* STABLE */
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  sm: "4"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Order By")
                                  ]),
                                  _: 1 /* STABLE */
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  sm: "8"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_select, {
                                      variant: "outlined",
                                      modelValue: __props.scanFilterStateV2.settings.scan.sort_by,
                                      "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((__props.scanFilterStateV2.settings.scan.sort_by) = $event)),
                                      items: Object.entries(__props.scanFilterStateV2.settings.scan.order_list).map(([value, title]) => ({ value, title })),
                                      density: "compact",
                                      "hide-details": ""
                                    }, null, 8 /* PROPS */, ["modelValue", "items"])
                                  ]),
                                  _: 1 /* STABLE */
                                }),
                                _createVNode(_component_v_col, { cols: "12" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_radio_group, {
                                      "hide-details": "true",
                                      modelValue: __props.scanFilterStateV2.settings.scan.sort_order,
                                      "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((__props.scanFilterStateV2.settings.scan.sort_order) = $event)),
                                      inline: "",
                                      class: "mt-4"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_radio, {
                                          label: "Ascending",
                                          value: "asc",
                                          density: "compact"
                                        }),
                                        _createVNode(_component_v_radio, {
                                          label: "Descending",
                                          value: "desc",
                                          density: "compact"
                                        })
                                      ]),
                                      _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["modelValue"])
                                  ]),
                                  _: 1 /* STABLE */
                                })
                              ]),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["class"]),
                    _createVNode(_component_v_expansion_panel, {
                      class: _normalizeClass({ 'bg-grey-lighten-4 my-2': panel.value.includes(2) }),
                      elevation: "0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_expansion_panel_title, {
                          class: "font-weight-bold px-0 my-n3 text-body-2",
                          "hide-actions": ""
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_94, [
                              _createVNode(_component_v_icon, {
                                class: "mt-n1",
                                size: "x-large",
                                icon: panel.value.includes(2) ? 'mdi-menu-down' : 'mdi-menu-right'
                              }, null, 8 /* PROPS */, ["icon"]),
                              _createTextVNode(),
                              _createVNode(_component_v_icon, { icon: "mdi-view-module" }),
                              _createTextVNode("Scan Category ")
                            ])
                          ]),
                          _: 1 /* STABLE */
                        }),
                        _createVNode(_component_v_expansion_panel_text, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_radio_group, {
                              modelValue: __props.scanFilterStateV2.settings.scan.category,
                              "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((__props.scanFilterStateV2.settings.scan.category) = $event)),
                              inline: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_radio, {
                                  label: "All  ",
                                  value: "all",
                                  density: "compact"
                                }),
                                _createVNode(_component_v_radio, {
                                  label: "Real-time  ",
                                  value: "real_time",
                                  density: "compact"
                                }),
                                _createVNode(_component_v_radio, {
                                  label: "Uploaded  ",
                                  value: "uploaded",
                                  density: "compact"
                                })
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["modelValue"]),
                            _hoisted_95,
                            _createElementVNode("table", _hoisted_96, [
                              (scanResults.value)
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_97, [
                                    _createElementVNode("th", {
                                      class: _normalizeClass(["valid handle", {'valid-color': scanResults.value.indexOf('1') > -1}]),
                                      onClick: _cache[54] || (_cache[54] = ($event: any) => ([showValidColor.value = !showValidColor.value, checkScanResult('1')])),
                                      id: "valid"
                                    }, [
                                      _createElementVNode("img", {
                                        src: _unref(asset)('icon/valid.png'),
                                        class: "visible-md-inline visible-lg-inline",
                                        alt: "valid"
                                      }, null, 8 /* PROPS */, _hoisted_98),
                                      _createTextVNode("Valid ")
                                    ], 2 /* CLASS */),
                                    _createElementVNode("th", {
                                      class: _normalizeClass(["invalid handle", {'invalid-color': scanResults.value.indexOf('0') > -1}]),
                                      onClick: _cache[55] || (_cache[55] = ($event: any) => ([showInvalidColor.value = !showInvalidColor.value,  checkScanResult('0')])),
                                      id: "invalid"
                                    }, [
                                      _createElementVNode("img", {
                                        src: _unref(asset)('icon/invalid.png'),
                                        class: "visible-md-inline visible-lg-inline",
                                        alt: "invalid"
                                      }, null, 8 /* PROPS */, _hoisted_99),
                                      _createTextVNode("Invalid ")
                                    ], 2 /* CLASS */),
                                    _createElementVNode("th", {
                                      class: _normalizeClass(["saved handle", {'saved-color': scanResults.value.indexOf('-1') > -1}]),
                                      onClick: _cache[56] || (_cache[56] = ($event: any) => ([showColor.value = !showColor.value,  checkScanResult('-1')])),
                                      id: "saved"
                                    }, [
                                      _createElementVNode("img", {
                                        src: _unref(asset)('icon/saved.png'),
                                        class: "visible-md-inline visible-lg-inline",
                                        alt: "saved"
                                      }, null, 8 /* PROPS */, _hoisted_100),
                                      _createTextVNode("Saved ")
                                    ], 2 /* CLASS */)
                                  ]))
                                : _createCommentVNode("v-if", true)
                            ])
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["class"]),
                    _createVNode(_component_v_expansion_panel, {
                      class: _normalizeClass({ 'bg-grey-lighten-4 my-2': panel.value.includes(3) }),
                      elevation: "0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_expansion_panel_title, {
                          class: "font-weight-bold px-0 my-n3 text-body-2",
                          "hide-actions": ""
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_101, [
                              _createVNode(_component_v_icon, {
                                class: "mt-n1",
                                size: "x-large",
                                icon: panel.value.includes(3) ? 'mdi-menu-down' : 'mdi-menu-right'
                              }, null, 8 /* PROPS */, ["icon"]),
                              _createTextVNode(),
                              _createVNode(_component_v_icon, { icon: "mdi-file" }),
                              _createTextVNode("Services ")
                            ])
                          ]),
                          _: 1 /* STABLE */
                        }),
                        _createVNode(_component_v_expansion_panel_text, null, {
                          default: _withCtx(() => [
                            (__props.scanFilterStateV2.loadingServices)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                                  _createVNode(_component_v_icon, { icon: "mdi-loading" }),
                                  _createTextVNode(" Loading Services ")
                                ]))
                              : _createCommentVNode("v-if", true),
                            _createElementVNode("div", _hoisted_103, [
                              (!__props.scanFilterStateV2.loadingServices)
                                ? (_openBlock(), _createBlock(_component_service_selector, {
                                    key: 0,
                                    modelValue: __props.scanFilterStateV2.settings.services.selected_ids,
                                    "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((__props.scanFilterStateV2.settings.services.selected_ids) = $event)),
                                    "deleted-services": __props.scanFilterStateV2.settings.services.deleted,
                                    "services-search-text": __props.scanFilterStateV2.settings.services.search_text,
                                    row: 1,
                                    "select-all": __props.scanFilterStateV2.settings.services.select_all,
                                    "onUpdate:selectAll": updateServiceSelectAll,
                                    usage: "scan-filter"
                                  }, null, 8 /* PROPS */, ["modelValue", "deleted-services", "services-search-text", "select-all"]))
                                : _createCommentVNode("v-if", true)
                            ])
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["class"]),
                    _createVNode(_component_v_expansion_panel, {
                      class: _normalizeClass({ 'bg-grey-lighten-4 my-2': panel.value.includes(4) }),
                      elevation: "0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_expansion_panel_title, {
                          class: "font-weight-bold px-0 my-n3 text-body-2",
                          "hide-actions": ""
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_104, [
                              _createVNode(_component_v_icon, {
                                class: "mt-n1",
                                size: "x-large",
                                icon: panel.value.includes(4) ? 'mdi-menu-down' : 'mdi-menu-right'
                              }, null, 8 /* PROPS */, ["icon"]),
                              _createTextVNode(),
                              _createVNode(_component_v_icon, { icon: "mdi-account" }),
                              _createTextVNode(" Users ")
                            ])
                          ]),
                          _: 1 /* STABLE */
                        }),
                        _createVNode(_component_v_expansion_panel_text, null, {
                          default: _withCtx(() => [
                            (__props.scanFilterStateV2.loadingUsers)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
                                  _createVNode(_component_v_icon, { icon: "mdi-loading" }),
                                  _createTextVNode("Loading Users ")
                                ]))
                              : _createCommentVNode("v-if", true),
                            _createElementVNode("div", _hoisted_106, [
                              (!__props.scanFilterStateV2.loadingUsers)
                                ? (_openBlock(), _createBlock(_component_user_selector, {
                                    key: 0,
                                    users: __props.scanFilterStateV2.users,
                                    modelValue: __props.scanFilterStateV2.settings.users.selected_ids,
                                    "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((__props.scanFilterStateV2.settings.users.selected_ids) = $event)),
                                    "show-include-deleted-users": true,
                                    "deleted-users": __props.scanFilterStateV2.settings.users.deleted,
                                    onChangeDeletedUsers: _cache[59] || (_cache[59] = ($event: any) => (__props.scanFilterStateV2.settings.users.deleted = $event)),
                                    "users-search-text": __props.scanFilterStateV2.settings.users.search_text,
                                    row: 1,
                                    "select-all": __props.scanFilterStateV2.settings.users.select_all,
                                    "show-label": false
                                  }, null, 8 /* PROPS */, ["users", "modelValue", "deleted-users", "users-search-text", "select-all"]))
                                : _createCommentVNode("v-if", true)
                            ])
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["class"]),
                    _createVNode(_component_v_expansion_panel, {
                      class: _normalizeClass({ 'bg-grey-lighten-4 my-2': panel.value.includes(5) }),
                      elevation: "0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_expansion_panel_title, {
                          class: "font-weight-bold px-0 my-n3 text-body-2",
                          "hide-actions": ""
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_107, [
                              _createVNode(_component_v_icon, {
                                class: "mt-n1",
                                size: "large",
                                icon: panel.value.includes(5) ? 'mdi-menu-down' : 'mdi-menu-right'
                              }, null, 8 /* PROPS */, ["icon"]),
                              _createTextVNode(),
                              _createVNode(_component_v_icon, { icon: "mdi-television" }),
                              _createTextVNode(" Devices ")
                            ])
                          ]),
                          _: 1 /* STABLE */
                        }),
                        _createVNode(_component_v_expansion_panel_text, null, {
                          default: _withCtx(() => [
                            (__props.scanFilterStateV2.loadingDevices)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                                  _createVNode(_component_v_icon, { icon: "mdi-loading" }),
                                  _createTextVNode("Loading Devices ")
                                ]))
                              : _createCommentVNode("v-if", true),
                            _createElementVNode("div", _hoisted_109, [
                              (!__props.scanFilterStateV2.loadingDevices)
                                ? (_openBlock(), _createBlock(_component_device_selector, {
                                    key: 0,
                                    devices: __props.scanFilterStateV2.devices,
                                    modelValue: __props.scanFilterStateV2.settings.devices.selected_ids,
                                    "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((__props.scanFilterStateV2.settings.devices.selected_ids) = $event)),
                                    "devices-search-text": __props.scanFilterStateV2.settings.devices.search_text,
                                    row: 1,
                                    "select-all": __props.scanFilterStateV2.settings.devices.select_all
                                  }, null, 8 /* PROPS */, ["devices", "modelValue", "devices-search-text", "select-all"]))
                                : _createCommentVNode("v-if", true)
                            ])
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["class"]),
                    (__props.scanFilterStateV2.settings.template.show)
                      ? (_openBlock(), _createBlock(_component_v_expansion_panel, {
                          key: 0,
                          class: _normalizeClass({ 'bg-grey-lighten-4 my-2': panel.value.includes(6) }),
                          elevation: "0"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_expansion_panel_title, {
                              class: "font-weight-bold px-0 my-n3 text-body-2",
                              "hide-actions": ""
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_110, [
                                  _createVNode(_component_v_icon, {
                                    class: "mt-n1",
                                    size: "large",
                                    icon: panel.value.includes(6) ? 'mdi-menu-down' : 'mdi-menu-right'
                                  }, null, 8 /* PROPS */, ["icon"]),
                                  _createTextVNode(),
                                  _createVNode(_component_v_icon, { icon: "mdi-file-export" }),
                                  _createTextVNode(" Export template ")
                                ])
                              ]),
                              _: 1 /* STABLE */
                            }),
                            _createVNode(_component_v_expansion_panel_text, null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_111, [
                                  _createVNode(_component_template_list, {
                                    modelValue: __props.scanFilterStateV2.settings.template.id,
                                    "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((__props.scanFilterStateV2.settings.template.id) = $event)),
                                    "field-container-title": 'Your CSV export will contain the following columns:',
                                    label: 'Output Format:',
                                    "additional-options": {'regular': 'All Data except properties (default)', 'regwithprops': 'All Data (including properties)'}
                                  }, null, 8 /* PROPS */, ["modelValue"])
                                ])
                              ]),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["class"]))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue"]),
                _hoisted_112,
                (__props.scanFilterStateV2.settings.showFilterButton)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      class: "text-none",
                      block: "",
                      disabled: __props.scanFilterStateV2.loadingServices,
                      color: "black",
                      type: "submit"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Filter")
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["disabled"]))
                  : _createCommentVNode("v-if", true),
                (__props.scanFilterStateV2.settings.showViewScansButton)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 1,
                      class: "text-none mt-3",
                      color: "black",
                      block: "",
                      onClick: showScans
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("View Scans")
                      ]),
                      _: 1 /* STABLE */
                    }))
                  : _createCommentVNode("v-if", true)
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }),
    _createVNode(_component_v_dialog, {
      modelValue: showScansModal.value,
      "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((showScansModal).value = $event)),
      "max-width": "800"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_toolbar, { dark: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_toolbar_title, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Filtered Scans")
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  icon: "",
                  dark: "",
                  onClick: _cache[63] || (_cache[63] = ($event: any) => (showScansModal.value = false))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-close")
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("h1", _hoisted_113, [
                  _createVNode(_component_v_progress_circular, { indeterminate: "" }),
                  _hoisted_114
                ], 512 /* NEED_PATCH */), [
                  [_vShow, __props.scanFilterStateV2.isLoading]
                ]),
                (!__props.scanFilterStateV2.isLoading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
                      _createElementVNode("div", null, [
                        _createElementVNode("h4", _hoisted_116, [
                          _createTextVNode(_toDisplayString(__props.scanFilterStateV2['paginator']['offset'] + 1) + " - " + _toDisplayString(__props.scanFilterStateV2['paginator']['offset'] + __props.scanFilterStateV2['scans'].length) + " of ", 1 /* TEXT */),
                          _withDirectives(_createVNode(_component_v_progress_circular, {
                            indeterminate: "",
                            size: "24"
                          }, null, 512 /* NEED_PATCH */), [
                            [_vShow, __props.scanFilterStateV2.isLoadingScansCount]
                          ]),
                          _withDirectives(_createElementVNode("span", null, _toDisplayString(parseInt(__props.scanFilterStateV2['paginator']['totalCount'])) + _toDisplayString(__props.scanFilterStateV2['paginator']['totalCount'] == __props.scanFilterStateV2['defaultTotalCount'] ? '+' : ''), 513 /* TEXT, NEED_PATCH */), [
                            [_vShow, !__props.scanFilterStateV2.isLoadingScansCount]
                          ]),
                          _createTextVNode(" Scans ")
                        ]),
                        (__props.scanFilterStateV2['paginator']['totalCount'] > 0)
                          ? (_openBlock(), _createBlock(_component_pagination, {
                              key: 0,
                              "paginator-data": __props.scanFilterStateV2['paginator'],
                              nav: false
                            }, null, 8 /* PROPS */, ["paginator-data"]))
                          : _createCommentVNode("v-if", true)
                      ]),
                      (__props.scanFilterStateV2.scans.length == 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_117, _hoisted_119))
                        : _createCommentVNode("v-if", true),
                      (__props.scanFilterStateV2.scans.length > 0 && showScansModal.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_120, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.scanFilterStateV2.scans, (scan) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: scan.id
                              }, [
                                _createVNode(_component_scan_card, {
                                  scan: scan,
                                  received: __props.scanFilterStateV2.settings.scan.data_received,
                                  scanFilterStateV2: __props.scanFilterStateV2
                                }, null, 8 /* PROPS */, ["scan", "received", "scanFilterStateV2"])
                              ]))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]))
                        : _createCommentVNode("v-if", true),
                      (__props.scanFilterStateV2['paginator']['totalCount'] > 0)
                        ? (_openBlock(), _createBlock(_component_pagination, {
                            key: 2,
                            "paginator-data": __props.scanFilterStateV2['paginator'],
                            nav: false
                          }, null, 8 /* PROPS */, ["paginator-data"]))
                        : _createCommentVNode("v-if", true)
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue"])
  ]))
}
}

})